import React, { useState } from 'react'
import building from '../../../../images/building.svg'
import location from '../../../../images/location.svg'
import clock from '../../../../images/clock.svg'
import bag from '../../../../images/bag.svg'
import bullet from '../../../../images/bullet.svg'
import { Container, Col, Row, Form, Button, Card} from 'react-bootstrap';
import { Link } from 'react-router-dom'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'
import { jobOptions } from '../../../../data'
import { useParams } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'


const ReadMore = () => {
    const [jobs,setJobs] = useState(jobOptions)
    const { id } = useParams();
    const job = jobs.find((jobs) => jobs.id === parseInt(id))
    if (!job) {
        return <div>Job not found</div>;
      }
    //   else{
    //     const{id,image,role,company,location,amount,datePosted,workMode,jobType,aboutUs,qualifications,jobDescription,industries}= job;
    //   }
    
  return (
    <div className='d-block d-lg-none'>
       <ProfileNavbar/>
       
      <Container fluid className='py-5 px-2'>
      <div className=' d-flex '>
              <Link to='/find' className=''>
                <FaArrowLeft  className='message-arrow'/>
              </Link>
              <h2 className='ps-3'>Find Jobs</h2>
           
           </div>
      <Card className='py-3 px-2 mt-5 border-0' style={{background: '#CCCCDD'}}>
                <div className='d-flex gap-3 description-header align-items-center'>
                  <img className='company-job-image' src={job.image}/>
                  <h1>{job.role}</h1>
                </div>
                <div className='d-block d-sm-flex justify-content-between align-items-center mt-3'>
                  <div className='align-items-center gap-2'>
                    <p className='company-building'><img src={building}/>&nbsp;{job.company}</p>
                    <p className='company-building'><img src={location}/> {job.location}</p>
                  </div>
                  <div className='d-flex  '>
                  <button className='company-apply-btn'>Apply Now</button>
                  </div>
                </div>
                <div className='apply-line'></div>
                <div className='about-us'>
                  <h4>About Us</h4>
                  <p>{job.aboutUs}</p>
                </div>
                <div className='apply-line'></div>
                <div className='job-details-section'>
                  <h4>Job Details</h4>
                  <div className=' d-xl-flex d-lg-block align-items-center justify-content-between selected-job-details-info'>
                  <div className='gap-2'>
                    <p className='job-type'><img src={bag} /> &nbsp; &nbsp;{job.jobType}, {job.workMode}</p>
                    <p className='job-type'><img src={clock}/> &nbsp;&nbsp;{job.datePosted}</p>
                  </div>
                  <h6>Salary Range: {job.amount}</h6>
                </div>
                </div>
                <div className='apply-line'></div>
                <Row className='gap-2'>
                <Col xl={5} md={12} className='qualifications-section'>
                  <h4>Qualifications</h4>
                  <div className='qualifications'>
                  {job.qualifications.map((qualification) => (
                    <div className='qualification'>
                      <img src={bullet}/>
                      <p>{qualification}</p>
                    </div>
                    ))} 
                  </div>

                </Col>
               
                <Col xl={6} md={12}  className='description-section'>
                  <h4>Job Description</h4>
                  <div className='descriptions'>
                  {job.jobDescription.map((description) => (
                    <div className='description-1' >
                      <img src={bullet}/>
                      <p>{description}</p>
                    </div>
                    ))} 
                  </div>

                </Col>
                </Row>
        </Card>
      </Container>
    </div>
  )
}

export default ReadMore
